module.exports = __webpack_public_path__ + "img/组 1.56185f6a.webp";